<script>
const minutesOfTime = (time = '00:00') => {
  const timeMatches = time.match(/^(\d+):(\d+)$/i)
  const [, hours, minutes] = timeMatches
  return Number(hours) * 60 + Number(minutes)
}

const initData = () => {
  return {
    start: '00:00',
    end: '23:59',
    lastOrder: '23:00',
    beforehandOrder: '0',
    beforehandOrderType: 'minute',
    isOpen: 0,
    timeRange: ['00:00', '23:59'],
    isLastOrderCrossDate: false
  }
}
const serviceTimeSetting = {
  1: { ...initData(), title: '週一' },
  2: { ...initData(), title: '週二' },
  3: { ...initData(), title: '週三' },
  4: { ...initData(), title: '週四' },
  5: { ...initData(), title: '週五' },
  6: { ...initData(), title: '週六' },
  7: { ...initData(), title: '週日' },
}

const week = ['週一', '週二', '週三', '週四', '週五', '週六', '週日']

export default {
  props: {
    itemType: {
      type: String,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      submitRules: {
        start: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) return callback(new Error('請選擇營業開始時間'))
              if (this.submitData.serviceTimeSetting.end) this.$refs.form.validateField('params.serviceTimeSetting.end')
              callback()
            },
            trigger: 'change',
          },
        ],
        end: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const { start } = this.submitData.serviceTimeSetting
              if (minutesOfTime(start) >= minutesOfTime(value)) return callback(new Error('結束時間不可早於開始時間'))
              callback()
            },
            trigger: 'change',
          },
        ],
        lastOrder: [
          {
            required: true,
            message: '請選擇時間',
            trigger: 'change',
          },
        ],
        beforehandOrder: [
          {
            required: true,
            message: '請輸入提前預約時間',
          },
        ],
      },
      week,
      serviceTimeSetting,
    }
  },
  computed: {
    isEditMode() {
      return this.defaultValue.id
    },
  },
  watch: {
  },
  created() {
    if (this.isEditMode) {
      this.serviceTimeSetting = { ...serviceTimeSetting, ...this.defaultValue.serviceTimeSetting }
      for (let i in this.serviceTimeSetting) {
        this.$set(this.serviceTimeSetting[i], 'timeRange', [this.serviceTimeSetting[i].start, this.serviceTimeSetting[i].end])
        this.$set(this.serviceTimeSetting[i], 'beforehandOrderType', this.serviceTimeSetting[i].beforehandOrderType ?? 'minute')
      }
    }
  },
  methods: {
    async validate() {
      let validateList = []
      for (let i in this.serviceTimeSetting) {
        validateList.push(this.$refs[`form${i}`][0].validate())
      }
      const result = await Promise.all(validateList)
      return result
    },
    /**
     * @description 將週一營業時間套用至所有營業日
     */
    fillAllTimes() {
      for (let i in this.serviceTimeSetting) {
        this.serviceTimeSetting[i].before = this.serviceTimeSetting['1'].before
        this.serviceTimeSetting[i].beforehandOrder = this.serviceTimeSetting['1'].beforehandOrder
        this.serviceTimeSetting[i].lastOrder = this.serviceTimeSetting['1'].lastOrder
        this.serviceTimeSetting[i].end = this.serviceTimeSetting['1'].end
        this.serviceTimeSetting[i].isOpen = this.serviceTimeSetting['1'].isOpen
        this.serviceTimeSetting[i].start = this.serviceTimeSetting['1'].start
        this.serviceTimeSetting[i].timeRange = [this.serviceTimeSetting[i].start, this.serviceTimeSetting[i].end]
        this.serviceTimeSetting[i].beforehandOrderType = this.serviceTimeSetting['1'].beforehandOrderType
        this.serviceTimeSetting[i].isLastOrderCrossDate = this.serviceTimeSetting['1'].isLastOrderCrossDate
      }
    },
    /**
     * timeRange按確認後的事項
     * @param {} item 此次按確認後改變的資料
     * @param {*} key 物件的key
     * @param {*} index 第幾個index
     */
    onPickSelectDate(item, key, index) {
      item.timeRange[0] = item.start
      item.timeRange[1] = item.end
    },
    validateBySelf() {
      let validate = true
      for (let i in this.serviceTimeSetting) {
        if (this.serviceTimeSetting[i].beforehandOrder < 0) {
          this.$message({
            type: 'error',
            message: `提前預約時間欄位需大於等於0`,
          })
          validate = false
        }
      }
      return validate
    }
  },
}
</script>

<template>
  <div :class="$style.serviceTime">
    <div :class="$style.serviceTime__upperTitle">
      <h4 class="form-block-title">營業時間</h4>
      <el-button class="is-round" @click="fillAllTimes">
        將週一營業時間套用至所有營業日
      </el-button>
    </div>
    <!-- 一般時間 -->
    <div v-for="(item, key, index) in serviceTimeSetting" :key="key" :class="$style.borderBottom">
      <el-form :ref="`form${key}`" :rules="submitRules" :model="serviceTimeSetting[key]" label-position="top"
        :style="key === '1' ? 'height:auto' : 'height:auto'" :class="$style.elForm">
        <el-row :gutter="20" :class="$style.timeRow">
          <div :class="$style.leftWeekText">
            <el-col :sm="4" :span="24" class="weekend">
              <el-switch v-model="serviceTimeSetting[key].isOpen" :active-value="1" :inactive-value="0"></el-switch>
              <div class="weekText">{{ week[index] }}</div>
              <div class="only-right-line h-30 mx-24"></div>
            </el-col>
          </div>
          <div style="display: flex;flex-direction:column;">
            <div>
              <el-col :sm="12" :span="24" style="padding-left: 0">
                <el-form-item label="營業時間">
                  <el-time-picker v-if="false" v-model="serviceTimeSetting[key].timeRange" class="bg-white is-border"
                    :clearable="false" range-separator="至" format="HH:mm" value-format="HH:mm" placeholder="選擇開始營業時間"
                    is-range @change="onPickSelectDate(item, key, index)">
                  </el-time-picker>
                  <div :class="$style.bussinessHour">
                    <el-time-picker v-model="serviceTimeSetting[key].start" format="HH:mm" value-format="HH:mm"
                      class="bg-white is-border" placeholder="開始營業時間" :clearable="false"
                      @change="onPickSelectDate(item, key, index)">
                    </el-time-picker>
                    <p>至</p>
                    <el-time-picker v-model="serviceTimeSetting[key].end" format="HH:mm" value-format="HH:mm"
                      class="bg-white is-border" placeholder="開始營業時間" :clearable="false"
                      @change="onPickSelectDate(item, key, index)">
                    </el-time-picker>
                  </div>
                </el-form-item>
                <!-- <el-button v-if="key === '1'" style="position:absolute" class="is-round" @click="fillAllTimes">
                將週一營業時間套用至所有營業日
              </el-button> -->
              </el-col>
              <el-col v-if="false" :sm="6" :span="24">
                <el-form-item label="最晚接受預約時間" prop="lastOrder" style="overflow-x:auto;">
                  <el-time-picker v-model="serviceTimeSetting[key].lastOrder" format="HH:mm" value-format="HH:mm"
                    class="bg-white is-border" placeholder="選擇最晚接受預約時間" :clearable="false">
                  </el-time-picker>
                </el-form-item>
              </el-col>
              <el-col :sm="6" :span="24" :class="$style.paddingRwdNone">
                <el-form-item label="提前預約時間" prop="beforehandOrder">
                  <el-input v-model.number="serviceTimeSetting[key].beforehandOrder" min="0"
                    class="bg-white is-round is-border group__append_no_border" type="number">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="6" :span="24" :class="$style.paddingRwdNone">
                <el-form-item label="時間單位">
                  <div class="timeUnit">
                    <el-radio v-model="serviceTimeSetting[key].beforehandOrderType" label="day">天</el-radio>
                    <el-radio v-model="serviceTimeSetting[key].beforehandOrderType" label="minute">分鐘</el-radio>
                  </div>
                </el-form-item>
              </el-col>
            </div>
            <div :class="$style.row2">
              <el-col :span="12" style="padding-left: 0">
                <el-form-item label="最晚接受預約時間" prop="lastOrder" style="overflow-x:auto;">
                  <el-time-picker v-model="serviceTimeSetting[key].lastOrder" format="HH:mm" value-format="HH:mm"
                    class="bg-white is-border" placeholder="選擇最晚接受預約時間" :clearable="false">
                  </el-time-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="row2__switch" :class="$style.paddingRwdNone">
                <p>時間是否為跨日</p>
                <el-switch v-model="serviceTimeSetting[key].isLastOrderCrossDate" :active-value="1"
                  :inactive-value="0"></el-switch>
              </el-col>
            </div>
          </div>
        </el-row>
      </el-form>
    </div>
  </div>
</template>



<style lang="scss" module>
.serviceTime {
  background-color: white;
  padding: 2.227px 20px 18px;

  &__upperTitle {
    display: flex;
    justify-content: space-between;
  }
}

.elForm {
  overflow: scroll;

  :global {
    .el-row {
      // overflow: scroll;
      min-width: 880px;
    }

    .timeUnit {
      display: flex;
      align-items: center;

      :global {
        .el-radio {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

.launchTimeRow {
  display: flex;
  align-items: center;
  border-bottom: $color-border-base 1px solid;

  :global {
    .h4Width {
      width: 126px;
      padding-top: 16px;
    }

    .morePadding {
      margin-right: 24px;
    }

    .timePickerWidth {
      flex-grow: 1;
    }

  }
}

.timeRow {
  display: flex;
  align-items: flex-start;
  height: auto;
  padding: 12px 0 0 0;


  :global {
    .el-switch {
      width: 56px;
      margin-right: 12px;
    }

    .el-checkbox {
      position: absolute;
      left: 0;
      bottom: -50px;
    }

    .weekend {
      display: flex;
      align-items: center;
    }

    .weekText {
      width: 40px !important;
      white-space: nowrap;
    }

    .el-form-item {
      label {
        height: 40px;
        overflow-x: auto;
      }
    }
  }
}

.allDay {
  height: 50px;
}

.borderBottom {
  border-bottom: $color-border-base 1px solid;
}

.leftWeekText {
  padding-top: 47px;
}

.bussinessHour {
  display: flex;
  align-items: center;

  >p {
    margin: 0 5px 0;
  }

  :global {
    .el-input.is-border .el-input__inner {
      padding-left: 30px;
      padding-right: 20px;
    }
  }
}

.paddingRwdNone {
  @media screen and (max-width: 768px) {
    padding-left: 0 !important;
  }
}

.row2 {
  display: flex;
  align-items: flex-end;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }

  :global {
    .row2__switch {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 21px;

      :global {
        p {
          width: 120px;
        }
      }
    }
  }
}</style>
